
import PaymentModal from '@/parts/account/PaymentModal.vue';
import QuitModal from '@/parts/account/QuitModal.vue';
import AccountUpdateCompleteModal from '@/parts/account/AccountUpdateCompleteModal.vue';
import ChangeModal from '@/parts/account/ChangeModal.vue';
import AddressChangeModal from '@/parts/account/AddressChangeModal.vue';

export default {
  QuitModal,
  PaymentModal,
  AccountUpdateCompleteModal,
  ChangeModal,
  AddressChangeModal,
};
